// eslint-disable-next-line no-unused-vars
import { FooterPartnerContent } from '../models';

const footerPartnersCCSContent: FooterPartnerContent[] = [
  {
    name: 'aps',
    src: 'https://cdn-dev.print-marketplace.co.uk/frontend/logo_aps_white.svg',
  },
  {
    name: 'pmp',
    src: 'https://cdn-dev.print-marketplace.co.uk/frontend/logo_pmp_white.svg',
  },
  {
    name: 'ccs',
    src: 'https://cdn-dev.print-marketplace.co.uk/frontend/logo_ccs_white.svg',
  },
];

export default footerPartnersCCSContent;
